import { useTranslation } from "react-i18next";
import config from "../../configuration/config";
import moment from "moment";
import { LoadingOutlined } from '@ant-design/icons';
export default function VehicleDetails({
  id,
  carBrand = '',
  carNameTitle = '',
  carModelTitle = '',
  isHybrid = false,
  colorImage,
  structureNo = '',
  plateNo = '',
  createdInput = '',
  values = [],
  showValues = false,
  carImage,
  userCarName = '',
  industryYear = '',
  fetchType,
  onUpdate,
  isLoadingUpdateSN
}) {
  const { t: trans, i18n } = useTranslation(["common", "vehicales", "form", "info"]);

  const lang = (i18n.language || 'ar');
  const languageDir = 'language-' + lang;
  const carInnerDetails = [
    { id: 1, description: trans("vehicales:veh-cle"), icon: '/assets/icons/specs/cylinder.svg' },
    { id: 2, description: trans("vehicales:veh-seat"), icon: '/assets/icons/specs/seats.svg' },
    { id: 3, description: trans("vehicales:veh-eng"), icon: '/assets/icons/specs/horse-power.svg' },
    { id: 4, description: trans("vehicales:veh-lettr"), icon: '/assets/icons/specs/petrol.svg' },
    { id: 5, description: trans("vehicales:veh-petrol"), icon: '/assets/icons/specs/petrol.svg' },
  ];
  return (
    <div className={'nice-container-fluid ' + languageDir}>
      <div className='nice-row'>
        <div className='nice-col-md-6 flex justify-center items-center'>

          <img className='vehicle-image-box' src={config.FilePathURL + carImage} alt={'info'} />
        </div>
        <div className='nice-col-md-6'>
          <div className='vehicle-details-box p-6 mt-5'>
            <div className='vehicle-details-box-brands my-3'>
              <div className='vehicle-details-box-brands-title flex'>{carNameTitle} </div>

              <div>
                <div className='nice-flex-row'>



                  {
                    isHybrid && <div className='vehicle-brand vehicle-brand-hybrid p-2 mx-3 text-center text-size-14r'>{trans("vehicales:veh-hybrid")}</div>
                  }
                  <div className='vehicle-brand vehicle-brand-primary p-2  text-center text-size-14r'>{carBrand}</div>
                </div>


              </div>
            </div>
            <div className='text-sub-color text-size-16r'>
              {carModelTitle}
            </div>
            <div className='text-sub-color text-size-16r my-3'>
              {industryYear}
            </div>
            <div className='nice-flex-row my-12'>
              <div className='text-16 text-sub-color'>
                {trans("form:color")} :
              </div>
              <div className='color-box' style={{ backgroundImage: `url('${(config.mainURL + colorImage).replaceAll("\\", "/")}')` }}>
              </div>
            </div>
            <div className='nice-row'>
              <div className='nice-col-md-6 ice-col-sm-12'>
                <div className='nice-flex-row my-8'>
                  <div className='text-16 text-sub-color'>
                    {trans("vehicales:veh-struc")} : {structureNo}
                  </div>
                </div>
              </div>
              <div className='nice-col-md-6 ice-col-sm-12'>
                <div className='nice-flex-row my-8'>
                  <div className='text-16 text-sub-color'>
                    {trans("vehicales:veh-plat")} : {plateNo}
                  </div>
                </div>
              </div>
            </div>
            <div className='nice-row'>
              <div className='nice-col-md-6 ice-col-sm-12'>
                <div className='nice-flex-row my-8'>
                  <div className='text-16 text-sub-color'>
                    {trans("vehicales:veh-created")} : {createdInput ? moment(createdInput).format('YYYY-MM-DD') : ""}
                  </div>
                </div>
              </div>
              <div className='nice-col-md-6 ice-col-sm-12 custom-ant'>
                <div className='nice-flex-row my-8 flex nice-flex-space'>
                  <div className='text-16 text-sub-color'>
                    {trans("new:VehicleUser")} : {userCarName}
                  </div>

                  {
                    structureNo &&

                    <div
                      onClick={() => {
                        if (onUpdate) {
                          onUpdate(id, structureNo, fetchType);
                        }
                      }}
                      className={"text-14 mx-5 icon-btn nice-pointer custom-ant"}>
                      {(isLoadingUpdateSN === structureNo ? true : false) ? <LoadingOutlined style={{ fontSize: '10px !important' }} /> :
                        <img title="تعديل" className={"inline filter-black size-21"} src="/assets/icons/edit.svg" alt="edit" />
                      }

                    </div>

                  }
                </div>
              </div>
            </div>
            <div className='nice-row'>
              <div className='nice-col-12'>
                {/* {
                  structureNo &&
                  <Button type="default" 
                  variant="filled" 
                  shape="default"
                    onClick={() => {
                      if (onUpdate && isLoadingUpdateSN != structureNo) {
                        onUpdate(id, structureNo, fetchType);
                      }
                    }}
                    color="default"
                    // loading={isLoadingUpdateSN == SN ? true : false}
                    loading={(isLoadingUpdateSN == structureNo ? true : false) && { icon: <LoadingOutlined style={{ fontSize: '2rem !important' }} /> }}
                    icon={<EditOutlined style={{ width: "3rem" }} />} size={"large"}
                    className=" "
                  />
                } */}

              </div>
            </div>
            <div className='nice-row nice-flex-center-items nice-show'>
              {
                showValues && carInnerDetails.map((e, i) => {
                  return <div className='nice-col-lg-2 nice-col-md-3 nice-col-sm-4' key={e.id}>
                    <div className='feature-car-box'>
                      <div className='feature-car-box-details text-center'>
                        <span className='text-block text-size-14 '>
                          {
                            values && values[i]
                          }
                        </span>
                        <span className='text-block text-size-14'>
                          {e.description}
                        </span>
                      </div>
                      <img alt="" src={`${e.icon}`} className='filter-black' />
                    </div>
                  </div>
                })
              }

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}